import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inputs"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 1,
  class: "checkbox-container"
}

import { Direction } from "@/models/Enums";
import { configVehicles } from "@/modules/Quickform/config/vehicles";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";
import { computed, reactive } from "vue";
import { VehicleItem } from "../../models/Vehicle";
import { VCheckbox, VInput, VSelect } from "v-ferry-components";
import { fueltypes } from "../../config/fuelTypes";

interface Props {
    vehicleIndex: number;
    vehicle: VehicleItem;
    direction: Direction;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleSelect',
  props: {
    vehicleIndex: {},
    vehicle: {},
    direction: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const state = reactive<VehicleItem>({
    resourceCode: props.vehicle.resourceCode ?? "",
    licenseNumber: props.vehicle.licenseNumber ?? "",
    length: props.vehicle.length ?? undefined,
    rental: props.vehicle.rental ?? false,
    fuelType: props.vehicle.fuelType ?? null,
});

const rules = {
    resourceCode: { required },
    licenseNumber: {
        required: requiredIf(function () {
            return !!currentVehicle.value?.hasLicensePlate && !state.rental;
        }),
    },
    length: {
        required: requiredIf(function () {
            return !!currentVehicle.value?.showLength;
        }),
    },
    rental: {},
    fuelType: {},
};

const v$ = useVuelidate(rules, state);

const currentVehicle = computed(() => {
    return configVehicles.find((v) => v.value === state.resourceCode);
});

const filteredFuelTypes = computed(() => {
  if (currentVehicle.value?.value === "BIC") {
    return fueltypes.filter(f => f.value === "E" || f.value === "");
  }
  return fueltypes.filter(f => f.value !== "");
});

const showFuelType = computed(() => {
  return (currentVehicle.value?.showFuelType &&
    (!state.rental || currentVehicle.value?.value === 'BIC')
  );
});

function onVehicleChange() {
  state.fuelType = null;

  if (currentVehicle.value?.value === "BIC") {
    state.licenseNumber = "";
  }
}

__expose({
    state,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(VSelect), {
      modelValue: _unref(v$).resourceCode.$model,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).resourceCode.$model) = $event)),
        onVehicleChange
      ],
      canClear: false,
      options: _unref(configVehicles),
      hasError: _unref(v$).resourceCode.$error,
      placeholder: "Select type of vehicle"
    }, null, 8, ["modelValue", "options", "hasError"]),
    (currentVehicle.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (currentVehicle.value.hasLicensePlate || currentVehicle.value.showLength || currentVehicle.value.showFuelType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (currentVehicle.value.hasLicensePlate && !_unref(v$).rental.$model)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "form-label" }, "License plate", -1)),
                      _createVNode(_unref(VInput), {
                        modelValue: _unref(v$).licenseNumber.$model,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).licenseNumber.$model) = $event)),
                        hasError: _unref(v$).licenseNumber.$error,
                        class: "license"
                      }, null, 8, ["modelValue", "hasError"])
                    ]))
                  : _createCommentVNode("", true),
                (showFuelType.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "form-label" }, "Fuel Type", -1)),
                      _createVNode(_unref(VSelect), {
                        modelValue: _unref(v$).fuelType.$model,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).fuelType.$model) = $event)),
                        canClear: false,
                        options: filteredFuelTypes.value,
                        hasError: _unref(v$).fuelType.$error,
                        placeholder: "Select fuel type",
                        class: "fuel-type"
                      }, null, 8, ["modelValue", "options", "hasError"])
                    ]))
                  : _createCommentVNode("", true),
                (currentVehicle.value.showLength)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "form-label" }, "Total length (M)", -1)),
                      _createVNode(_unref(VInput), {
                        modelValue: _unref(v$).length.$model,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).length.$model) = $event)),
                        hasError: _unref(v$).length.$error,
                        type: "tel"
                      }, null, 8, ["modelValue", "hasError"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (currentVehicle.value.hasLicensePlate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(VCheckbox), {
                  class: "checkbox",
                  modelValue: _unref(v$).rental.$model,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).rental.$model) = $event)),
                  id: Math.random().toString()
                }, null, 8, ["modelValue", "id"]),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "Rental car/Unknown license plate", -1))
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})